import React, {Component} from "react";

export class Loader extends Component<any, any> {

    render() {
        return (
            <div className="error-page">
                <div>
                    <section className="loader-holder">
                        <img className="loader" src="/images/loading.gif" alt="Be patient..."/>
                    </section>
                </div>
            </div>
        );
    }
}